import { IButtonStyles } from '@fluentui/react/lib/Button';
import { getPalette } from 'owa-theme';
import { FontWeights } from '@uifabric/styling';
import { IIconStyles } from '@fluentui/react/lib/Icon';

export function getFilterButtonStyles(): IButtonStyles {
    const palette = getPalette();

    return {
        root: {
            border: 'none',
            padding: '0 4px',
            marginRight: '8px',
            borderRadius: '15px',
        },
        rootHovered: {
            backgroundColor: palette.neutralLight,
        },
        rootChecked: {
            backgroundColor: palette.themeLighterAlt,
            color: palette.themeDarker,
        },
        label: {
            fontWeight: FontWeights.regular,
        },
    };
}

export function getIconStyles(): IIconStyles {
    return {
        root: {
            color: getPalette().themeDarker,
        },
    };
}
